import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const toISO = (d) =>
  d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";
export const fromISO = (s) => (s ? new Date(s + "T00:00:00") : undefined);

export function DateField({ value, onChange, disabled, placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const selected = fromISO(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full h-11 rounded-xl border border-border bg-sand px-3 text-sm font-semibold text-ink flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-canard">
          <span className={selected ? "text-ink" : "text-muted2"}>
            {selected ? selected.toLocaleDateString() : placeholder}
          </span>
          <CalendarIcon className="w-4 h-4 text-muted2 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} disabled={disabled}
          onSelect={(d) => { onChange(toISO(d)); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
